import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const initializeMenuHeader = () => {
    document.addEventListener("DOMContentLoaded", function () {
        const menuToggle = document.getElementById("menu-toggle");
        const menuMobile = document.getElementById("menu-mobile");
        const menuDesktop = document.getElementById("menu");
        const abrirIcon = menuToggle.querySelector(".abrir-menu");
        const fecharIcon = menuToggle.querySelector(".fechar-menu");

        const menuMain = document.getElementById("menu-main");
        const submenuScreens = document.querySelectorAll(".submenu-screen");

        const isMobile = () => window.innerWidth < 768;

        function updateMenuVisibility() {
            if (isMobile()) {
                menuToggle.classList.remove("hidden");
                menuDesktop.classList.add("hidden");
                menuMobile.classList.add("hidden");
                abrirIcon.classList.remove("hidden");
                fecharIcon.classList.add("hidden");
                showMainMenu();
            } else {
                menuToggle.classList.add("hidden");
                menuDesktop.classList.remove("hidden");
                menuMobile.classList.add("hidden");
                abrirIcon.classList.remove("hidden");
                fecharIcon.classList.add("hidden");
                showMainMenu();
            }
        }

        function showMainMenu() {
            if (menuMain) {
                menuMain.classList.remove("hidden");
            }
            submenuScreens.forEach(screen => screen.classList.add("hidden"));

            // Volta todas as setas para a posição original (direita)
            document.querySelectorAll(".submenu-toggle .submenu-arrow").forEach(arrow => {
                arrow.classList.remove("rotate-90");
            });
        }

        // Abrir ou fechar o menu mobile
        menuToggle.addEventListener("click", () => {
            const isNowClosed = menuMobile.classList.contains("hidden");

            menuMobile.classList.toggle("hidden", !isNowClosed);

            abrirIcon.classList.toggle("hidden", isNowClosed);
            fecharIcon.classList.toggle("hidden", !isNowClosed);

            if (isNowClosed) {
                showMainMenu();
            }
        });

        const closeMobileBtn = document.getElementById("close-mobile-menu");
        if (closeMobileBtn) {
            closeMobileBtn.addEventListener("click", () => {
                menuMobile.classList.add("hidden");
                abrirIcon.classList.remove("hidden");
                fecharIcon.classList.add("hidden");
                showMainMenu();
            });
        }

        // Submenu: abre tela do submenu e gira a seta
        document.querySelectorAll(".submenu-toggle").forEach(button => {
            button.addEventListener("click", () => {
                const targetId = button.getAttribute("data-target");
                const targetMenu = document.getElementById(targetId);

                if (targetMenu) {
                    menuMain.classList.add("hidden");
                    targetMenu.classList.remove("hidden");

                    // Gira a seta apenas do botão clicado
                    document.querySelectorAll(".submenu-toggle .submenu-arrow").forEach(arrow => {
                        arrow.classList.remove("rotate-90");
                    });

                    const arrow = button.querySelector(".submenu-arrow");
                    if (arrow) {
                        arrow.classList.add("rotate-90");
                    }
                }
            });
        });

        // Voltar do submenu
        document.querySelectorAll(".back-btn").forEach(button => {
            button.addEventListener("click", () => {
                showMainMenu();
            });
        });

        // Fecha o menu mobile ao clicar em qualquer link
        menuMobile.querySelectorAll("a").forEach(link => {
            link.addEventListener("click", () => {
                if (isMobile()) {
                    menuMobile.classList.add("hidden");
                    abrirIcon.classList.remove("hidden");
                    fecharIcon.classList.add("hidden");
                    showMainMenu();
                }
            });
        });

        window.addEventListener("resize", updateMenuVisibility);
        updateMenuVisibility();
    });
};

export default initializeMenuHeader;
